import React from "react";
import { ClipboardList, Calculator, FileSignature, Landmark } from "lucide-react";

const STEPS = [
  {
    n: "01",
    icon: ClipboardList,
    title: "Log the invoice",
    body: "Capture buyer details, invoice & acceptance dates, and the 45-day statutory credit-period cap. Attach a documentary evidence checklist.",
  },
  {
    n: "02",
    icon: Calculator,
    title: "Auto-compute interest",
    body: "Baaki applies the dated RBI Bank Rate for each month × 3, with monthly rests, per Section 16 — the exact statutory basis, not a guess.",
  },
  {
    n: "03",
    icon: FileSignature,
    title: "Generate demand notice",
    body: "A templated notice with statutory citations, principal and accrued interest, ready to review, export as PDF, or send by email.",
  },
  {
    n: "04",
    icon: Landmark,
    title: "Escalate to Samadhaan",
    body: "If unpaid past 45 days post-notice, track the case through MSEFC conciliation and arbitration under Section 18 — or engage the Legal Desk.",
  },
];

export const HowItWorks = () => (
  <section id="how" className="border-b border-border bg-white">
    <div className="max-w-6xl mx-auto px-6 py-24">
      <div className="max-w-2xl">
        <span className="font-mono text-[11px] uppercase tracking-[0.2em] text-signal">
          The recovery workflow
        </span>
        <h2 className="mt-3 font-serif text-4xl font-semibold tracking-tight text-ink">
          From stuck invoice to statutory recovery
        </h2>
        <p className="mt-4 text-sm leading-relaxed text-muted-foreground">
          The MSMED Act, 2006 already entitles you to interest and a fast-track dispute
          forum. Most MSMEs never claim it because the process is opaque. Baaki makes it
          a checklist.
        </p>
      </div>

      <div className="mt-14 grid md:grid-cols-2 lg:grid-cols-4 border-t border-l border-border">
        {STEPS.map((s) => (
          <div
            key={s.n}
            data-testid={`step-${s.n}`}
            className="border-r border-b border-border p-7 hover:bg-secondary transition-colors duration-150"
          >
            <div className="flex items-center justify-between">
              <s.icon className="h-6 w-6 text-signal" strokeWidth={1.5} />
              <span className="font-mono text-xs text-muted-foreground">{s.n}</span>
            </div>
            <h3 className="mt-5 font-serif text-2xl font-semibold text-ink">{s.title}</h3>
            <p className="mt-2.5 text-[13px] leading-relaxed text-muted-foreground">{s.body}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);
